import { History } from "history"
import { combineReducers } from "redux"
import {ismagCriteriaReducer} from "../../modules/ismagquery/criteria/reducer"
import { ismagReducer } from "../../modules/ismagquery/results/reducer"
import { ccbReducer } from "../../modules/ccb/results/reducer"
import { ccbCriteriaReducer } from "../../modules/ccb/criteria/reducer"
import { resultTableReducer } from "../../components/results-table-cl/reducer"
import { depoCriteriaReducer } from "../../modules/depository/criteria/reducer"
import { depositoryReducer } from "../../modules/depository/results/reducer"


export type AppState = {
    blnAppDisclaimerAgreed: boolean,
    blnAppDisclaimerRejected: boolean,
    externalWindowContent?: JSX.Element
    externalWindowTitle?: string
  }

type AppAction =
  | {
      type: "App/DISCLAIMERACCEPT"
    }
  | {
      type: "App/DISCLAIMERREJECT"
    }
  | {
      type: "App/DISCLAIMERRESET"
    }
  | {
      type: "App/EXTWINDOWOPEN", 
      content: JSX.Element,
      windowTitle?: string
    }
    | {
      type: "App/EXTWINDOWTITLE",       
      windowTitle?: string
    }
  |  {   type: "App/EXTWINDOWCLOSE"  }


const initialState: AppState = { blnAppDisclaimerAgreed: false, blnAppDisclaimerRejected: false, externalWindowTitle: "" }

 


const appReducer = (
        state: AppState = initialState,
        action: AppAction 
    ) => {
        // console.log("in AppReducer state without content" + JSON.stringify({blnAppDisclaimerAgreed:state.blnAppDisclaimerAgreed, blnAppDisclaimerRejected:state.blnAppDisclaimerRejected}) + " tms:" + Date.now())
        // console.log("in AppReducer state action: " + action.type + " tms:" + Date.now())
        switch (action.type) {
            case "App/DISCLAIMERACCEPT":
              return { ...state,  blnAppDisclaimerAgreed: true }
            case "App/DISCLAIMERREJECT":
              return { ...state,  blnAppDisclaimerRejected: true }
            case "App/DISCLAIMERRESET":
                return { ...state,   blnAppDisclaimerRejected: false }
            case "App/EXTWINDOWOPEN": 
                console.log( "In EXTWINDOWOPEN" + action.content)
                return {...state, externalWindowContent: action.content, externalWindowTitle: action.windowTitle}
            case "App/EXTWINDOWTITLE": 
                console.log( "In EXTWINDOWTITLE" + action.windowTitle)
                return {...state, externalWindowTitle: action.windowTitle}                
            case "App/EXTWINDOWCLOSE" :
                console.log( "In EXTWINDOWCLOSE" )
                return {...state, externalWindowContent: undefined, externalWindowTitle: ""}
            default: return state
        }
    }

export type SearchHistoryState = {
  searchHistoryState?: Object
}

export type SearchHistoryAction =  
  |{
      type: "SearchHistory",
      searchHistory: Object
    }
  |{ type: "ResetHistory",}
const initialSearchHistoryState: SearchHistoryState = {}

export const searchHistoryReducer = (
        state: SearchHistoryState = initialSearchHistoryState,
        action: SearchHistoryAction ) => {
          switch (action.type) {
            case "SearchHistory":
              return { ...state,  searchHistoryState: action.searchHistory }
            case "ResetHistory" :
              return { ...state,  searchHistoryState: {} }
            default: return state
        }
      }

const rootReducerInst = combineReducers({
    appReducer,
    ismagCriteriaReducer,
    ismagReducer,
    ccbReducer,
    ccbCriteriaReducer, 
    resultTableReducer,
    depoCriteriaReducer,
    depositoryReducer,
    searchHistoryReducer
  // disclaimerReducer,
  // filestoreListReducer,
  // settingReducer,
  // profileReducer,
})




export const connectReducer = (history: History) => rootReducerInst


export type RootReducer = ReturnType<typeof rootReducerInst>